// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"8dec5ee9","533":"94b6516c"}[chunkId] + ".chunk.css";
};